import { render } from "./GameSection.vue?vue&type=template&id=ba2fe53c&scoped=true"
import script from "./GameSection.vue?vue&type=script&lang=js"
export * from "./GameSection.vue?vue&type=script&lang=js"

import "./GameSection.vue?vue&type=style&index=0&id=ba2fe53c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba2fe53c"]])

export default __exports__